import { LoginFormContextProvider } from "./login-form/login-form.context";
import { useTranslation } from "react-i18next";
import WelcomeMessageComponent from "./welcome-message/welcome-message.component";
import LoginFormComponent from "./login-form/login-form.component";
import styles from "./login-v3.styles.module.scss";

const LoginV3Component = () => {
  const { t } = useTranslation();
  return (
    <div className={styles.root}>
      <div className={styles.contentWrapper}>
        <div role="complementary" className={styles.leftSection}>
          <WelcomeMessageComponent />
        </div>
        <section aria-label={t("login form section")} className={styles.rightSection}>
          <LoginFormContextProvider>
            <LoginFormComponent />
          </LoginFormContextProvider>
        </section>
      </div>
      <div className={styles.triangle} />
    </div>
  );
};

export default LoginV3Component;
